/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useState } from 'react';
import { TasksTable } from '@/components/TasksTable';
import { PageHeader, Tabs } from '@/components/ui';

type T = 'mine' | 'created' | 'watching' | 'overdue' | 'done';

export function TasksPage() {
  const [tab, setTab] = useState<T>('mine');
  const filter = tab === 'overdue' ? { scope: 'mine', overdue: 'true' } : tab === 'done' ? { scope: 'mine' } : { scope: tab };
  return (
    <>
      <PageHeader title="Задачи" />
      <Tabs<T> value={tab} onChange={setTab} tabs={[
        { id: 'mine', label: 'Мне' }, { id: 'overdue', label: 'Просроченные' }, { id: 'created', label: 'Поставил я' },
        { id: 'watching', label: 'Наблюдаю' }, { id: 'done', label: 'Выполненные' },
      ]} />
      <TasksTable key={tab} filter={filter} showDone={tab === 'done'} />
    </>
  );
}
